import React, { ReactElement } from 'react';

export interface ICountryItem {
  name: string;
  two_digit_code: string;
  three_digit_code: string;
  numeric: number;
}

interface ITaxLabel {
  label: string;
}

export interface ITaxRequiredCountries {
  BR: ITaxLabel;
  CN: ITaxLabel;
  KR: ITaxLabel;
  MX: ITaxLabel;
}

export interface IShippingRules {
  tax_required_countries: ITaxRequiredCountries;
  marketplace_allowed_countries?: string[];
}

export enum BackgroundTypeEnum {
  Color = 'color',
  Image = 'image',
}

export enum DomEventEnum {
  Scroll = 'scroll',
  Resize = 'resize',
  MouseDown = 'mousedown',
  Wheel = 'wheel',
}

export enum KeyboardKeyEnum {
  Enter = 'Enter',
  Space = ' ',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
}

export enum HorizontalCardVariantEnum {
  Default = 'default',
  Suboption = 'suboption',
}

export enum ClaimPageStepEnum {
  PickYourGift = 'pick-your-gift',
  CustomizeOptions = 'customize-options',
  CustomizeItems = 'customize-items',
  Address = 'address',
}

export enum ImagePositionEnum {
  Center = 'center',
  Cover = 'cover',
  Contain = 'contain',
  Percents = 'percents',
}

export enum ImageFitEnum {
  Cover = 'cover',
  Contain = 'contain',
}

export enum DescriptionSourceEnum {
  Inventory = 'inventory',
  Marketplace = 'marketplace',
}

export enum FabFaceEnum {
  Down = 'down',
  Up = 'up',
  Hidden = 'hidden',
}

export interface IScrollThresholds {
  hideAt: number;
  showAt: number;
}

export interface IScrollGuidanceState {
  barVisible: boolean;
  fabState: FabFaceEnum;
  down: boolean;
  up: boolean;
}

export interface IUseScrollGuidanceOptions {
  anchorRef: React.RefObject<HTMLElement> | undefined;
  downEnabled?: boolean;
  upEnabled?: boolean;
  mobileDownThresholds?: boolean;
  downAnchorRef?: React.RefObject<HTMLElement> | undefined;
  downThresholds?: IScrollThresholds;
  upThresholds?: IScrollThresholds;
  downHideAt?: number;
  downIgnoresBar?: boolean;
}

export interface IUseScrollGuidanceResult extends IScrollGuidanceState {
  suppressUntilSettle: () => void;
}

export interface IStickyToolbarState {
  isStuck: boolean;
  isCondensed: boolean;
}

export interface IUseStickyToolbarOptions {
  sentinelRef: React.RefObject<HTMLElement>;
  stickyTop: number;
  condenseAfter?: number;
  isSearchFocused?: boolean;
}

export interface IUseInfiniteScrollOptions {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
  threshold?: number;
  recheckKey?: unknown;
}

export interface IScrollMetrics {
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
}

// The marketplace route carries the page it was opened from, whose branding it keeps.
export interface IBrandingLocationState {
  from?: string;
}

export interface IFabFaceConfig {
  label: string;
  bannerLabel?: string;
  onActivate: (behavior: ScrollBehavior) => void;
}

export interface IFabConfig {
  down?: IFabFaceConfig;
  up?: IFabFaceConfig;
  desktopFabEnabled: boolean;
  downAnchorRef?: React.RefObject<HTMLElement>;
  downThresholds?: IScrollThresholds;
  upThresholds?: IScrollThresholds;
  downHideAt?: number;
  downIgnoresBar?: boolean;
}

export interface IFooterState {
  backButton?: ReactElement;
  helperText?: ReactElement;
  submitButton: ReactElement;
}

export interface ISelectorValue {
  value: string;
  label: string;
  disabled?: boolean;
}
